import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { View } from 'react-native';
import Animated, { useAnimatedScrollHandler, useSharedValue } from 'react-native-reanimated';
import { rem, AppView, SCREEN_BOTTOM_PADDING, SCROLL_INDICATOR_INSETS, NavigationHeader } from 'design-system';
import Choices from 'design-system/Choices';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { useAppDispatch } from 'store/hooks';
import LeaveOnboardingButton from 'features/wealth/components/LeaveOnboardingButton';
import { OnboardingFlow } from 'utils/types/navigation';
import useNavigateToNextScreen from '../hooks/useNavigateToNextScreen';
const CHOICES = ['Yes, I do', "No, I don't"];
const ISAExistingAccountCheck = ({ route, navigation }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const dispatch = useAppDispatch();
    const scrollY = useSharedValue(0);
    const mountedOnAnotherScreen = route.params?.mountedOnAnotherScreen;
    const { paddingHorizontalStyle } = useAppFrameDimensions(mountedOnAnotherScreen);
    const contentContainerStyles = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    const navigateToNextScreen = useNavigateToNextScreen();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const onSelect = useCallback((item) => {
        if (item === CHOICES[0]) {
            navigation.navigate('PickExistingISAAccounts');
            return;
        }
        dispatch({ type: 'SAVE_ONBOARDING_STATE', accountsHeldElsewhere: [] });
        navigateToNextScreen();
    }, [navigateToNextScreen]);
    const scrollHandler = useAnimatedScrollHandler(({ contentOffset }) => {
        scrollY.value = contentOffset.y;
    });
    const headerColors = useMemo(() => [colors.background.dark, colors.cards.onDark], [colors.background.dark, colors.cards.onDark]);
    return (<AppView withFrame={false}>
      <NavigationHeader scrollY={scrollY} regularTitleHeight outputColors={headerColors} isInTab={!!mountedOnAnotherScreen} leftContent={mountedOnAnotherScreen ? <LeaveOnboardingButton flow={OnboardingFlow.Invest}/> : undefined} rightContent={<View style={!!mountedOnAnotherScreen && styles.rightBtnContainer}>
            <HelpScreenButton />
          </View>}/>
      <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" contentContainerStyle={contentContainerStyles} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
        <ScreenInfoHeader title="Do you have an ISA elsewhere?"/>

        <View style={styles.choicesContainer}>
          <Choices data={CHOICES} onSelect={onSelect}/>
        </View>
      </Animated.ScrollView>
    </AppView>);
};
const styleSet = createStyleSheets(() => ({
    choicesContainer: {
        paddingHorizontal: rem(16),
    },
    rightBtnContainer: {
        marginRight: rem(16),
        marginBottom: rem(6),
        alignItems: 'flex-end',
    },
}));
export default ISAExistingAccountCheck;
